import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import type { NodeItem } from '@models/flows';

const VALUE_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
] as const;

type ValueType = (typeof VALUE_TYPES)[number]['value'];

type ValueNodeConfigProps = {
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function ValueNodeConfiguration({ currentNode, onChange }: ValueNodeConfigProps) {
  if (!currentNode) return null;
  const valueType = currentNode.code as ValueType;
  const handleTypeChange = (type: ValueType) => {
    onChange({
      ...currentNode,
      code: type,
      value: '',
    });
  };

  const handleValueChange = (rawValue: string) => {
    const value = valueType === 'number' ? (rawValue === '' ? '' : Number(rawValue)) : rawValue;
    onChange({
      ...currentNode,
      value,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <FormControl fullWidth>
        <InputLabel id="value-type-label">Type</InputLabel>
        <Select
          labelId="value-type-label"
          label="Type"
          value={valueType}
          disabled={true} // TOOD: remove this once we have generic settings node
          onChange={(e) => handleTypeChange(e.target.value as ValueType)}
          sx={{ width: 300 }}>
          {VALUE_TYPES.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <TextField
          label="Value"
          type={valueType === 'number' ? 'number' : 'text'}
          value={currentNode.value ?? ''}
          onChange={(e) => handleValueChange(e.target.value)}
          sx={{ width: 300 }}
        />
      </FormControl>
    </div>
  );
}

export default ValueNodeConfiguration;
